// extracted by mini-css-extract-plugin
export default {"circleTag":"src-components-Antd-Tag-css__circleTag--BqmxM"};